import React, { useState } from 'react';
import './AdminPanel.css';

import Dashboard from './Dashboard';
import Users from './users';
import Conversations from './conversations';
 // xzx

const AdminPanel = () => {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  const renderContent = () => {
    switch (activeTab) {
      case 'dashboard': return <Dashboard />;
      case 'users': return <Users />;
      case 'conversations': return <Conversations />;
      
      default: return <Dashboard />;
    }
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setIsSidebarOpen(false); // close mobile sidebar after selection
  };

  return (
    <div className="admin-container">
      {/* ☰ Mobile Toggle Button */}
      <div className="mobile-sidebar-toggle" onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
        ☰
      </div>

      {/* Topbar */}
      <div className="admin-topbar">
        <div className="topbar-left">
          <span className="topbar-title">Admin Panel</span>
        </div>
        <div className="topbar-right">
          <span className="admin-name">Super Admin</span>
          <div className="profile-icon">👤</div>
        </div>
      </div>

      <div className="admin-layout">
        {/* Sidebar */}
        <aside className={`admin-sidebar ${isSidebarCollapsed ? 'collapsed' : ''} ${isSidebarOpen ? 'open-mobile' : 'hide-mobile'}`}>
          <div className="sidebar-toggle" onClick={() => setIsSidebarCollapsed(!isSidebarCollapsed)}>
            {isSidebarCollapsed ? ">" : "<"}
          </div>
          <ul className="sidebar-nav">
            <li onClick={() => handleTabClick('dashboard')} className={activeTab === 'dashboard' ? 'active' : ''}>
              📊 {!isSidebarCollapsed && 'Dashboard'}
            </li>
            <li onClick={() => handleTabClick('users')} className={activeTab === 'users' ? 'active' : ''}>
              👥 {!isSidebarCollapsed && 'Users'}
            </li>
            <li onClick={() => handleTabClick('conversations')} className={activeTab === 'conversations' ? 'active' : ''}>
              💬 {!isSidebarCollapsed && 'Conversations'}
            </li>
            <li className="logout">
              🔴 {!isSidebarCollapsed && 'Logout'}
            </li>
          </ul>
        </aside>

        {/* Main Content */}
        <main className="admin-main-content">
          {renderContent()}
        </main>
      </div>
    </div>
  );
};

export default AdminPanel;
